<template>
    <v-row id="route-segments">
        <v-col cols="12" class="mb-4 " v-for="route in routes" :key="route.name">
            <v-card
            elevation="2"
            @click="editRoute(route.routeId)"
            >
                <v-row class="pt-5 pb-5 pr-10 pl-10">
                    <v-col cols="12" class="p-0">
                        <p class="routes">
                            {{route.name}}
                        </p>
                    </v-col>

                    <v-col cols="6" class="p-0">
                        <p class="routes-date">
                           {{ route.transportationStartDate | formatOnlyDate }}
                        </p>
                    </v-col>
                    <v-col cols="6" class="p-0">
                        <p class="routes-km text-right">
                            <!--{{route.kms}} Km-->
                        </p>
                    </v-col>

                    <v-col cols="3" class="p-0 mt-3 d-flex align-center">
                        <span>
                            <img src="/images/_SVGs/environmental/oficinas.svg" alt="oficinas" onload="SVGInject(this)" width="20" height="20"/> {{route.doneEgars}}/{{route.totalEgars}}
                        </span>
                    </v-col>
                    <v-col cols="9" class="p-0 mt-3 d-flex align-center" style="justify-content: flex-end; height: 28px;">
                        <v-progress-linear :value="calcPercentual(route.totalEgars,route.doneEgars)" ></v-progress-linear>
                    </v-col>
                </v-row>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        props:{
            routes: Array | Object
        },
        data(){
            return{

            }
        },
        methods:{
            editRoute(id){
                this.$router.push({ name: 'environmentalManagementRouteManagementEditConveyor', params: { id: id }})
            },
            
            calcPercentual(total, done){
                if(done > 0){
                    let calc = (done * 100);
                    return calc / total;
                }
                return 0
            },
        }
    }
</script>

<style lang="scss" scoped>
@import '@sass/_variables.scss';
#route-segments{
    p{
        font-size: 14px;
        margin-bottom: 0;
        &.routes {
            color: var(--v-primary-base);
            font-weight: 500;
            cursor: pointer;
        }
        &.routes-date{
            font-size: 14px;
            color: $grey;
            font-weight: bold;
        }
    }
    .btn-primary{
        background-color: var(--v-primary-base);
        color: #fff;
        ::v-deep .v-btn__content{
            font-size: 10px;
        }
        
    }
}
</style>